export default __webpack_public_path__ + "images/e8b92173b39e54930dce1de42cb82377-psychedlic.webp";